import { PropertyDisplayConfiguration } from './property-display-configuration.model';

export interface GetPaymentListConfigurationsResponse {
  paymentListConfigs?: PropertyDisplayConfiguration[];
}

export interface SetPaymentListConfigurations {
  paymentListConfigurations?: PropertyDisplayConfiguration[];
}
